// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, string } from 'prop-types'
import { Field } from 'redux-form'
import { AutoSuggest } from 'components/Form'
import { fetchRadioFamiliesContaining } from 'helpers/api'

const rfn = 'radioFamily'

const RadioModelFamilies = ({ handleSelection, idRoot, name }) => (
  <Field
    component={AutoSuggest}
    fetchSuggestions={fetchRadioFamiliesContaining}
    handleSelection={handleSelection}
    id={`${idRoot}-radio-family`}
    label={`Model Family`}
    name={name}
    optionKey={rfn}
    sortKey={rfn} />
)

RadioModelFamilies.propTypes = {
  handleSelection: func.isRequired,
  idRoot: string.isRequired,
  name: string.isRequired,
}

export default RadioModelFamilies
